import {
  GET_RECIPIENTS_SUMMARY_WATCHER,
  GET_RECIPIENTS_SUMMARY_SUCCESS,
  GET_RECIPIENTS_SUMMARY_FAILED,
  UPLOAD_TEMPLATE_RECIPIENTS_WATCHER,
  UPLOAD_TEMPLATE_RECIPIENTS_SUCCESS,
  UPLOAD_TEMPLATE_RECIPIENTS_FAILED,
  SAVE_EXCEL_RECIPIENTS_WATCHER,
  SAVE_EXCEL_RECIPIENTS_SUCCESS,
  SAVE_EXCEL_RECIPIENTS_FAILED,
  SAVE_EXCEL_RECIPIENTS_PROGRESS,
} from "./constants"

// SAVE EXCEL COLLABORATORS
export function saveExcelRecipientsWatcher(payload) {
  return {
    type: SAVE_EXCEL_RECIPIENTS_WATCHER,
    payload,
  }
}

export function saveExcelRecipientsSuccess(payload) {
  return {
    type: SAVE_EXCEL_RECIPIENTS_SUCCESS,
    payload,
  }
}

export function saveExcelRecipientsFailed() {
  return { type: SAVE_EXCEL_RECIPIENTS_FAILED }
}

export function saveExcelRecipientsProgress(payload) {
  return {
    type: SAVE_EXCEL_RECIPIENTS_PROGRESS,
    payload,
  }
}

// GET SUMMARY COLLABORATORS
export function getRecipientsSummaryWatcher() {
  return { type: GET_RECIPIENTS_SUMMARY_WATCHER }
}

export function getRecipientsSummarySuccess(payload) {
  return {
    type: GET_RECIPIENTS_SUMMARY_SUCCESS,
    payload,
  }
}

export function getRecipientsSummaryFailed() {
  return { type: GET_RECIPIENTS_SUMMARY_FAILED }
}

// UPLOAD EXCEL
export function uploadTemplateRecipientsWatcher(payload) {
  return {
    type: UPLOAD_TEMPLATE_RECIPIENTS_WATCHER,
    payload,
  }
}

export function uploadTemplateRecipientsSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_RECIPIENTS_SUCCESS,
    payload,
  }
}

export function uploadTemplateRecipientsFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_RECIPIENTS_FAILED,
    payload,
  }
}
